export class ISession {
  public dealer: boolean;
}
